// Centralized client-side auth helper utilities.
// Used by both demo (NO_SERVER) mode and real authenticated mode.

const DEMO_LOGIN_KEY = 'PI_SCHEDULE_DEMO_ADMIN_LOGGED_IN';

/**
 * Persist a demo "admin logged in" flag.
 * @param {boolean} value
 */
export const setDemoLoggedIn = (value) => {
    try {
        if (value) {
            localStorage.setItem(DEMO_LOGIN_KEY, '1');
        } else {
            localStorage.removeItem(DEMO_LOGIN_KEY);
        }
    } catch (e) {
        // localStorage might be unavailable (e.g., private mode)
        console.error('[authService] Failed to store demo login flag:', e);
    }
};

/**
 * Check if the demo "admin logged in" flag is set.
 * This is intentionally synchronous so it can be used in guards.
 * @returns {boolean}
 */
export const isDemoLoggedIn = () => {
    try {
        const value = localStorage.getItem(DEMO_LOGIN_KEY);
        return value === '1' || value === 'true';
    } catch (e) {
        return false;
    }
};

/**
 * Clear the demo login flag.
 */
export const clearDemoLogin = () => {
    try {
        localStorage.removeItem(DEMO_LOGIN_KEY);
    } catch (e) {
        // Ignore
    }
};

/**
 * Centralized auth helper:
 * Returns true if the app should consider the user authenticated
 * either via a real auth token or via the demo virtual login flag.
 */
export const hasEffectiveAuth = (user) => {
    // Demo virtual login always counts as authenticated
    if (isDemoLoggedIn()) {
        return true;
    }
    // Fallback to real token-based auth
    return !!(user && user.token);
};

export default {
    setDemoLoggedIn,
    isDemoLoggedIn,
    clearDemoLogin,
    hasEffectiveAuth
};


